import React from 'react';
import { URL_AUTH } from '../../utils/Constant';

const AuthPage = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const paramsObj = {};
    urlParams.forEach((value, key) => {
        paramsObj[key] = value;
    });
    if(paramsObj?.token){
        // Установка куки напрямую
        const date = new Date();
        date.setTime(date.getTime() + (7 * 24 * 60 * 60 * 1000)); // 7 дней
        document.cookie = `refresh-token=${encodeURIComponent(paramsObj.token)}; expires=${date.toUTCString()}; path=/;`;
    } else {
        window.location.href = URL_AUTH;
    }
    window.location.href = '/';

  return (
    <>
      <div></div>
    </>
  );
};

export default AuthPage;